'use strict';

import angular from 'angular';

export function Modal($rootScope, $uibModal) {
	'ngInject';

	// Opens a modal
	// @param  {Object} scope      - an object to be merged with modal's scope
	// @param  {String} modalClass - (optional) class(es) to be applied to the modal
	// @return {Object}            - the instance $uibModal.open() returns
	function openModal(scope = {}, modalClass = 'modal-default') {
		var modalScope = $rootScope.$new();

		angular.extend(modalScope, scope);

		return $uibModal.open({
			template: require('./modal.html'),
			windowClass: modalClass,
			scope: modalScope
		});
	}

	// Public API here
	return {

		// Confirmation modals
		confirm: {

			// Create a function to open a delete confirmation modal (ex. ng-click='myModalFn(name, arg1, arg2...)')
			// @param  {Function} del - callback, ran when delete is confirmed
			// @return {Function}     - the function to open the modal (ex. myModalFn)
			delete(del = angular.noop) {
				
				// Open a delete confirmation modal
				// @param  {String} name   - name or info to show on modal
				// @param  {All}           - any additional args are passed straight to del callback
				return function () {
					var args = Array.prototype.slice.call(arguments);
					var params = args.shift();
					
					var btnClasses = null;
					if (params.classes)
					{
						if (params.classes.includes("warning")) btnClasses = "btn-warning";
						else if (params.classes.includes("info")) btnClasses = "btn-info";
						else if (params.classes.includes("success")) btnClasses = "btn-success";
						else if (params.classes.includes("primary")) btnClasses = "btn-primary";
					}

					var deleteModal = openModal({
						modal: {
							dismissable: true,
							header: params.header,
							title: params.title || 'DIALOG_DeleteTitle',
							html: params.html, // `<p>Are you sure you want to delete <strong>${params.name}</strong> ?</p>`,
							buttons: 
							[{
								classes: btnClasses || 'btn-danger',
								text: params.btnAccept || 'DELETE',
								click(e) { deleteModal.close(e); }
							},
							{
								classes: 'btn-default',
								text: params.btnCancel || 'CANCEL',
								click(e) { deleteModal.dismiss(e); }
							}]
						},
						vm: params.vm
					}, params.classes || 'modal-danger');

					deleteModal.result.then(function (event) {
						del.apply(event, args);
					}, function() {
						// No borrar esta funcion porque sino angular se queja de unhandled rejection
					});
				};
			}
		}
	};
}

export default angular.module('everlaps.Modal', [])
	.factory('Modal', Modal)
	.name;



// WEBPACK FOOTER //
// ./client/components/modal/modal.service.js